var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRhapsodyGraphicMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 564,
    viewBox: "0 0 388 564",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.62 126.943L248 131.417",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.726 53V110.644",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.12 75.6757L253.857 116.402",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.426 100.718L249.594 122.778",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.238 58.8614L260.225 112.134",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.516 135.788H248.05",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.518 140.929H248.052",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.518 146.124H248.052",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.12 75.6757L253.857 116.402",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.007 115.323L248.463 126.481",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.847 88.4268L251.238 119.64",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.267 66.4191L256.682 114.036",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.418 54.5406L263.823 111.002",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.038 130.336H287.453",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.436 75.6757L281.7 116.402",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.131 100.718L285.963 122.778",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.315 58.8614L275.328 112.134",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.038 130.336H287.453",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.038 140.672H287.453",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.038 151.008H287.453",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.038 161.397H287.453",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.038 171.731H287.453",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.038 182.067H287.453",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.038 192.403H287.453",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.038 202.79H287.453",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.436 75.6757L281.7 116.402",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.549 115.323L287.093 126.481",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.709 88.4268L284.319 119.64",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.288 66.4191L278.873 114.036",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.136 54.5406L271.681 111.002",
    stroke: "#050F1A",
    strokeWidth: 1.15418,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.353 366H371.647C372.943 366 374 367.128 374 368.513V399.487C374 400.872 372.943 402 371.647 402H309.353C308.057 402 307 400.872 307 399.487V368.513C307 367.077 308.057 366 309.353 366Z",
    fill: "#23C5BF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0125 155H245.059C249.463 155 253 157.794 253 161.272V202.728C253 206.206 249.463 209 245.059 209H76.0125C71.6094 209 68 206.206 68 202.728V161.272C68.0729 157.794 71.6094 155 76.0125 155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 182H235",
    stroke: "#050F1A",
    strokeWidth: 1.44272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.689 190.639C110.565 190.639 114.518 186.682 114.518 181.8C114.518 176.919 110.565 172.962 105.689 172.962C100.812 172.962 96.859 176.919 96.859 181.8C96.859 186.682 100.812 190.639 105.689 190.639Z",
    fill: "#FA7E2E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.134 343.069H353.462C356.082 343.069 358.189 345.177 358.189 347.8V411.46C358.189 414.083 356.082 416.191 353.462 416.191H311.134C308.514 416.191 306.408 414.083 306.408 411.46V347.8C306.408 345.177 308.514 343.069 311.134 343.069Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.7283 330.664L63.0291 336.007C62.5477 336.554 62.5477 337.437 63.0291 337.985L67.7283 343.328",
    stroke: "#050F1A",
    strokeWidth: 1.44272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.064 369.288L257.763 364.213C258.244 363.692 258.244 362.854 257.763 362.333L253.064 357.258",
    stroke: "#050F1A",
    strokeWidth: 1.44272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.846 426.908L218.916 431.612C219.436 432.094 220.274 432.094 220.794 431.612L225.864 426.908",
    stroke: "#050F1A",
    strokeWidth: 1.44272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2302 363.792H96.0997C97.3325 363.792 98.3604 364.769 98.3604 366.003V430.538C98.3604 431.772 97.3838 432.749 96.0997 432.749H52.2302C50.9974 432.749 49.9695 431.772 49.9695 430.538V366.003C50.0214 364.769 50.9974 363.792 52.2302 363.792Z",
    fill: "#FA7E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.242 363.535H218.102C212.194 363.535 207.366 358.701 207.366 352.788V313.348",
    stroke: "#050F1A",
    strokeWidth: 1.44272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1753 337.104H171.409C178.138 337.104 183.583 331.654 183.583 324.917V313.348",
    stroke: "#050F1A",
    strokeWidth: 1.44272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.448 313.348V381.687C195.448 388.424 200.893 393.926 207.674 393.926C214.403 393.926 219.9 399.377 219.9 406.164V431.155",
    stroke: "#050F1A",
    strokeWidth: 1.44272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0582 338.036C52.5851 334.785 50.3788 331.721 47.1307 331.193C43.8819 330.665 40.821 332.873 40.2941 336.125C39.7666 339.377 41.9729 342.441 45.221 342.969C48.4698 343.497 51.5306 341.288 52.0582 338.036Z",
    fill: "#1A81F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.569 449C222.895 449 224.781 447.112 224.781 444.784C224.781 442.455 222.895 440.567 220.569 440.567C218.242 440.567 216.357 442.455 216.357 444.784C216.357 447.112 218.242 449 220.569 449Z",
    fill: "#23C5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.075 369.602C280.792 369.602 283.805 366.586 283.805 362.866C283.805 359.146 280.792 356.13 277.075 356.13C273.359 356.13 270.346 359.146 270.346 362.866C270.346 366.586 273.359 369.602 277.075 369.602Z",
    fill: "#FA7E2E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.564 379.631H140.43C145.67 379.631 149.883 383.848 149.883 389.093V407.45C149.883 412.696 145.67 416.912 140.43 416.912H83.564C78.324 416.912 74.1119 412.696 74.1119 407.45V389.093C74.1632 383.9 78.3759 379.631 83.564 379.631Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.466 410.381C137.133 410.381 142.538 404.971 142.538 398.297C142.538 391.623 137.133 386.213 130.466 386.213C123.799 386.213 118.394 391.623 118.394 398.297C118.394 404.971 123.799 410.381 130.466 410.381Z",
    fill: "#23C5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.264 392.178V384.722H319.815C318.993 384.722 318.325 384.054 318.325 383.23V376.032C318.325 375.209 318.993 374.54 319.815 374.54H327.264V367.084C327.264 366.261 327.932 365.593 328.753 365.593H335.945C336.767 365.593 337.435 366.261 337.435 367.084V374.54H344.883C345.706 374.54 346.374 375.209 346.374 376.032V383.23C346.374 384.054 345.706 384.722 344.883 384.722H337.435V392.178C337.435 393 336.767 393.669 335.945 393.669H328.753C327.88 393.669 327.264 393 327.264 392.178Z",
    fill: "#FA7E2E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M38.9938 84.4517H99.9186C102.538 84.4517 104.644 86.5602 104.644 89.1828V121.27C104.644 123.893 102.538 126.001 99.9186 126.001H38.9938C36.3738 126.001 34.2675 123.893 34.2675 121.27V89.1828C34.2675 86.6114 36.3738 84.4517 38.9938 84.4517Z",
    fill: "#1A81F4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9517 113.969C62.5984 113.969 76.9041 99.6487 76.9041 81.9841C76.9041 64.3195 62.5984 50 44.9517 50C27.305 50 13 64.3195 13 81.9841C13 99.6487 27.305 113.969 44.9517 113.969Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.6948 84.3509L39.8661 94.5839L60.2088 74.1693",
    stroke: "#050F1A",
    strokeWidth: 1.44272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M103.673 497H217.97C219.46 497 220.642 498.183 220.642 499.674V559.117C220.642 560.609 219.46 561.791 217.97 561.791H103.673C102.183 561.791 101.002 560.609 101.002 559.117V499.674C100.95 498.183 102.183 497 103.673 497Z",
    fill: "#7340E4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_5_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.309 541.179H194.6C192.288 541.179 190.388 539.276 190.388 536.962V470.216C190.388 467.903 192.288 466 194.6 466H235.593C237.699 466 239.754 466.823 241.244 468.366L246.946 474.073C248.436 475.564 249.309 477.621 249.309 479.73V541.179Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.274 521.227H236.157",
    stroke: "#28213A",
    strokeWidth: 1.44272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.274 530.535H224.24",
    stroke: "#28213A",
    strokeWidth: 1.44272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.647 493.254C212.272 493.254 216.02 489.501 216.02 484.873C216.02 480.244 212.272 476.491 207.647 476.491C203.023 476.491 199.274 480.244 199.274 484.873C199.274 489.501 203.023 493.254 207.647 493.254Z",
    fill: "#7340E4",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.184 0H163.671C168.859 0 173.123 4.21701 173.123 9.46169V26.9965C173.123 32.1905 168.911 36.4582 163.671 36.4582H104.184V0Z",
    fill: "#7340E4",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.185 36.4069C114.228 36.4069 122.37 28.2572 122.37 18.2034C122.37 8.15036 114.228 0 104.185 0C94.1415 0 86 8.15036 86 18.2034C86 28.2572 94.1415 36.4069 104.185 36.4069Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_99",
    x: 61.7335,
    y: 155,
    width: 197.533,
    height: 66.533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.26649
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13325
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_99"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_99",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5_99",
    x: 300.142,
    y: 343.069,
    width: 64.3137,
    height: 85.6551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.26649
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13325
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_99"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_99",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5_99",
    x: 67.8454,
    y: 379.631,
    width: 88.3036,
    height: 49.8137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.26649
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13325
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_99"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_99",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5_99",
    x: 6.73351,
    y: 50,
    width: 76.437,
    height: 76.5018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.26649
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13325
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_99"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_99",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_5_99",
    x: 184.121,
    y: 466,
    width: 71.4539,
    height: 87.7117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.26649
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13325
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_99"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_99",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhapsodyGraphicMobile);
export default __webpack_public_path__ + "static/media/rhapsody-graphic-mobile.a04b4a6e798c99e07aaf9c7125c0303f.svg";
export { ForwardRef as ReactComponent };